import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState, useRef, useEffect } from 'react';
import { styled } from '@pixel/core/styles';
import IconButton from '@pixel/core/IconButton';
import { Button } from '@pixel/core/Button';
import Typography from '@pixel/core/Typography';
import AutoSelect from '@pixel/core/AutoSelect';
import ErrorBoundary from '@pixel/core/ErrorBoundary';
import sortArray from 'sort-array';
import RemoveIcon from "@pixel/assets/icons/Close"; //todo @pixel
import { VerticalDragDropList, DragDropContext, dragEndNewCollectionMap } from "../DragDrop";
//import Fade from '@mui/material/Fade';

import SortUnknownIcon from '@pixel/assets/icons/SortUnknown';
import SortUpIcon from '@pixel/assets/icons/SortUp';
import SortDownIcon from '@pixel/assets/icons/SortDown';
const ListItem = styled('div')(() => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  overflow: "hidden",
  transition: "opacity 4s ease-in"
}));
const ListItemContent = styled('div')(() => ({
  flex: "1 0 10%",
  overflow: 'hidden',
  textOverflow: "ellipsis",
  whiteSpace: 'nowrap'
}));
const ListItemActions = styled('div')(() => ({}));
const ListItemContentOverflow = styled(Typography)(() => ({
  minWidth: 0,
  //https://css-tricks.com/flexbox-truncated-text/
  overflow: 'hidden',
  textOverflow: "ellipsis",
  whiteSpace: 'nowrap'
}));
const SelectFilterRoot = styled('div')(() => ({
  flex: 1,
  display: "block"
}));
const SelectFilterRootSelect = styled('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    flex: 1,
    minWidth: 320,
    display: "flex",
    padding: theme.spacing(1, 0)
  };
});
const SelectFilterAugmentButton = styled('div')(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    display: "flex",
    "& button": {
      whiteSpace: "nowrap",
      padding: theme.size.focusWidth,
      marginLeft: theme.spacing(1)
    }
  };
});

// exporting as jsx because tsx cross npm build is not outputting d.ts files yet

const usePrevious = value => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
const arrayEqualSorted = (a, b) => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;
  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};
const SortDragMultiList = _ref3 => {
  let {
    addLabel = "Add",
    sortLabel = "Sort",
    disabled = false,
    error = false,
    allowRemove = true,
    onChange = () => {},
    ...props
  } = _ref3;
  const {
    id,
    droppableId,
    options,
    helperText,
    optionsLabel,
    optionsPlaceholder,
    selectedOptions,
    ...restProps
  } = props;
  const collectAvailableOptions = () => options.filter(option => !Boolean(selectedOptions.find(selectedOption => selectedOption.id == option.id)));
  const [availableOptions, setAvailableOptions] = useState(collectAvailableOptions());
  const [availableValue, setAvailableValue] = useState(null);
  const [isSorting, setIsSorting] = useState(false);
  const [isSortUnknown, setIsSortUnknown] = useState(true);
  const [hasSortedAsc, setHasSortedAsc] = useState(false);

  // const prevProps = usePrevious({selectedOptions});

  useEffect(() => {
    setAvailableOptions(collectAvailableOptions());
    setAvailableValue(null);
  }, [selectedOptions, options]);
  useEffect(() => {
    if (!isSorting) {
      const sortedSelectedOptionsAsc = sortSelectedOptionsReturnNew(true);
      const sortstate_ids = sortedSelectedOptionsAsc.map(option => option.id);
      const current_ids = selectedOptions.map(option => option.id);
      const sortsAreEqualAscState = arrayEqualSorted(sortstate_ids, current_ids);
      const sortsAreEqualDescState = arrayEqualSorted(sortstate_ids.reverse(), current_ids);
      if (!(sortsAreEqualAscState || sortsAreEqualDescState)) {
        resetSortState();
      } else {
        setHasSortedAsc(sortsAreEqualAscState);
        setIsSortUnknown(false);
      }
    }
    setIsSorting(false);
  }, [selectedOptions]);
  const resetSortState = () => {
    setIsSortUnknown(true);
    setHasSortedAsc(false);
  };
  const sortSelectedOptionsReturnNew = isSortAsc => {
    const newSelectedOptions = [...selectedOptions];
    sortArray(newSelectedOptions, {
      by: "label_lowercase",
      order: isSortAsc ? 'asc' : 'desc',
      computed: {
        "label_lowercase": selectedOption => selectedOption.label.toLowerCase()
      }
    });
    return newSelectedOptions;
  };
  const handleSort = e => {
    const isSortAsc = isSortUnknown || !hasSortedAsc;
    const newSelectedOptions = sortSelectedOptionsReturnNew(isSortAsc);
    setIsSorting(true);
    setIsSortUnknown(false);
    setHasSortedAsc(isSortAsc);
    onChange(e, newSelectedOptions);
  };
  const handleAdd = e => {
    const newSelectedOptions = [...selectedOptions]; //clone items
    newSelectedOptions.push(availableValue);
    onChange(e, newSelectedOptions);
    setAvailableValue(null);
    resetSortState();
  };
  const handleRemove = (e, collectionItem) => {
    const newSelectedOptions = [...selectedOptions]; //clone items
    let index = newSelectedOptions.findIndex(option => option.id == collectionItem.id);
    newSelectedOptions.splice(index, 1);
    onChange(e, newSelectedOptions);
  };
  const handleDragEnd = dropInfo => {
    let map = {};
    map["drop_" + id] = [...selectedOptions];
    const newCollectionMap = dragEndNewCollectionMap(dropInfo, map);
    //console.log("dropInfo", dropInfo)
    if (newCollectionMap != false) {
      resetSortState();
      onChange(null, newCollectionMap["drop_" + id]);
    }
  };
  const renderItemContent = collectionItem => {
    return /*#__PURE__*/React.createElement(ListItem, null, /*#__PURE__*/React.createElement(ListItemContent, null, /*#__PURE__*/React.createElement(ListItemContentOverflow, {
      variant: "subtitle1"
    }, collectionItem.label)), allowRemove != false && /*#__PURE__*/React.createElement(ListItemActions, null, /*#__PURE__*/React.createElement(IconButton, {
      disabled: disabled,
      size: "small",
      "aria-label": "Remove",
      onClick: e => handleRemove(e, collectionItem)
    }, /*#__PURE__*/React.createElement(RemoveIcon, null))));
  };
  const renderVerticalDragList = (droppableId, selectedOptions) => {
    return /*#__PURE__*/React.createElement(VerticalDragDropList, {
      droppableId: droppableId,
      disabled: disabled,
      DragContainerProps: {
        variant: "contained",
        dense: false
      },
      collection: selectedOptions,
      collectionIdKey: "id",
      renderContent: collectionItem => renderItemContent(collectionItem)
    });
  };
  const drawSelectedOptions = selectedOptions;
  return /*#__PURE__*/React.createElement(SelectFilterRoot, null, /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(SelectFilterRootSelect, null, /*#__PURE__*/React.createElement(AutoSelect, {
    id: id,
    value: availableValue
    // ref={refAuto}
    ,
    onChange: (e, v) => {
      setAvailableValue(v);
    },
    onKeyPress: e => {
      if (e.charCode == 13 && Boolean(availableValue)) {
        handleAdd(e);
      }
    },
    options: availableOptions,
    label: optionsLabel,
    disabled: disabled,
    error: error,
    helperText: helperText,
    placeholder: optionsPlaceholder,
    augmentField: () => /*#__PURE__*/React.createElement(SelectFilterAugmentButton, null, /*#__PURE__*/React.createElement(Button, {
      "aria-label": addLabel + ": " + optionsLabel,
      size: "large",
      variant: "contained",
      disabled: disabled || !Boolean(availableValue),
      onClick: handleAdd
    }, addLabel), /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": sortLabel + ": " + optionsLabel,
      disabled: disabled,
      onClick: handleSort
    }, isSortUnknown ? /*#__PURE__*/React.createElement(SortUnknownIcon, null) : hasSortedAsc ? /*#__PURE__*/React.createElement(SortUpIcon, null) : /*#__PURE__*/React.createElement(SortDownIcon, null)))
  })), isSorting && "sort", /*#__PURE__*/React.createElement("div", null, Boolean(droppableId) ? renderVerticalDragList(droppableId, drawSelectedOptions) : /*#__PURE__*/React.createElement(DragDropContext, {
    onDragEnd: handleDragEnd
  }, renderVerticalDragList("drop_" + id, drawSelectedOptions)))));
};
export default SortDragMultiList;